import { useState, useEffect } from 'react';
import AffiliatesService from '../services/affiliatesService';

const useDeviceManager = (customerId, cp, return_url, limit) => {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [quantityToRemove, setQuantityToRemove] = useState(0);
    const affiliatesService = new AffiliatesService();

    const fetchDevices = async () => {
        try {
            const fetchedDevices = await affiliatesService.getDevices(customerId, cp);
            const updatedDevices = fetchedDevices.map(device => ({
                ...device,
                deleted: false,
            }));
            setDevices(updatedDevices);
        } catch (error) {
            console.error(error);
            setDevices([]);
        } finally {
            setLoading(false);
        }
    };

    const deleteDevices = async () => {
        const deviceTokens = selectedDevices.map(device => device.token).join('|');
        try {
            const response = await affiliatesService.deleteDevice({
                deviceToken: deviceTokens,
                return_url,
                customerId: devices[0].customer.id,
                cp,
            });
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    const markDevice = (device) => {
        setSelectedDevices(prevSelectedDevices => {
            if (prevSelectedDevices.find(selectedDevice => selectedDevice.token === device.token)) {
                return prevSelectedDevices.filter(selectedDevice => selectedDevice.token !== device.token);
            }
            return [...prevSelectedDevices, device];
        });
    };

    const markAllDevices = () => {
        setSelectedDevices(devices);
    }

    const getQuantity = () => {
        return (devices.length + 1) - limit;
    };

    useEffect(() => {
        fetchDevices();
    }, [customerId, cp]);

    useEffect(() => {
        setQuantityToRemove(getQuantity());
    }, [devices]);

    useEffect(() => {
        // When reached the limit, automatically delete the devices
        if (quantityToRemove > 0 && selectedDevices.length >= quantityToRemove) {
            deleteDevices().then((response) => {
                if (response && !response.error && response.token) {
                    window.location.href = `${return_url}?one_time_token=${response.token}`;
                } else {
                    console.error(response.error || "Failed to delete device");
                }
            });
        }
    }, [selectedDevices]);

    return {
        devices,
        loading,
        quantityToRemove,
        markDevice,
        selectedDevices,
        markAllDevices
    };
};

export default useDeviceManager;
